module.exports = __webpack_public_path__ + "img/graph-image.5c6e3c4a.png";